export enum JackpotType {
    none = 0,
    small,
    big
}
